/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp18 } from './commonProp18';
import { commonProp4 } from './commonProp4';

export const pc_notebooks : {[key: string]: Array<[string, string]>} = {
    p_type: [
        ["PC_MONITOR", "Monitor"],
        ["DESKTOP", "Stoln\u00ed po\u010d\u00edta\u010d"],
        ["NOTEBOOK", "Notebook"],
        ["MODEMS_ROUTERS", "Modemy a routery"],
        ["NOTEBOOK_COVERS", "Pouzdra na notebook"],
        ["NOTEBOOK_BAGS_BACKPACKS", "Ta\u0161ky a batohy na notebook"],
        ["NOTEBOOK_DECORATIONS", "N\u00e1lepky a ozdoby na notebook"],
        ["PRINTERS", "Tisk\u00e1rny a multifunk\u010dn\u00ed za\u0159\u00edzen\u00ed"],
        ["TONERS_CARTRIDES", "Tonery a n\u00e1pln\u011b"],
        ["PC_ACCESSORIES", "P\u0159\u00edslu\u0161enstv\u00ed"],
    ],
    p_brand: commonProp18,
    p_color: commonProp4,
};
